import PropTypes from "prop-types";
import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { CustomerFormDialog } from "../customer-form-dialog";

import { Button } from "@mui/material";

export const AddCustomerFormDialog = ({ onClose, onSubmitted }) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({
    name,
    gender,
    dateOfBirth,
    email,
    phoneNumbers,
    accountingActionChartOfAccounts,
  }) => {
    try {
      await apiClient.post("customers", {
        name,
        gender,
        dateOfBirth,
        email,
        phoneNumbers,
        accountingActionChartOfAccounts,
      });

      if (onSubmitted) {
        onSubmitted();
      }
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan pelanggan"));

      throw error;
    }
  };

  return (
    <CustomerFormDialog
      onClose={onClose}
      dialogTitle="Tambah Pelanggan"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddCustomerFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func,
};
